import type { HeadlineType } from '@/types'
import useContentfulVariation from './useContentfulVariation'

export default function useContentfulSearchFormHeadlines(
  name: string,
  shouldFireImpression = true
) {
  const searchForm = useContentfulVariation<HeadlineType>(
    name,
    shouldFireImpression
  )
  return searchForm ?? null
}
